import ImagesIconsDashboardAccountDetailsHeadingSvg from '@/public/images/icons/dashboard/account-details-heading.svg';
import ImagesIconsDashboardAccountSvg from '@/public/images/icons/dashboard/account.svg';
import ImagesIconsDashboardBellSvg from '@/public/images/icons/dashboard/bell.svg';
import ImagesIconsDashboardBuyerProfileSvg from '@/public/images/icons/dashboard/buyer-profile.svg';
import ImagesIconsDashboardCheckWhiteSvg from '@/public/images/icons/dashboard/check-white.svg';
import ImagesIconsDashboardDashboardSvg from '@/public/images/icons/dashboard/dashboard.svg';
import ImagesIconsDashboardFeedbackSvg from '@/public/images/icons/dashboard/feedback.svg';
import ImagesIconsDashboardFileTextSvg from '@/public/images/icons/dashboard/file-text.svg';
import ImagesIconsDashboardLanguageSvg from '@/public/images/icons/dashboard/language.svg';
import ImagesIconsDashboardLeftSvg from '@/public/images/icons/dashboard/left.svg';
import ImagesIconsDashboardLogoutSvg from '@/public/images/icons/dashboard/logout.svg';
import ImagesIconsDashboardPortfolioSvg from '@/public/images/icons/dashboard/portfolio.svg';
import ImagesIconsDashboardReferralsSvg from '@/public/images/icons/dashboard/referrals.svg';
import ImagesIconsDashboardSandClockSvg from '@/public/images/icons/dashboard/sand-clock.svg';
import ImagesIconsDashboardSecuritySvg from '@/public/images/icons/dashboard/security.svg';
import ImagesIconsDashboardSellerProfileSvg from '@/public/images/icons/dashboard/seller-profile.svg';
import ImagesIconsDashboardSellingSvg from '@/public/images/icons/dashboard/selling.svg';
import ImagesIconsDashboardServicesSvg from '@/public/images/icons/dashboard/services.svg';
import ImagesIconsDashboardSettingsSvg from '@/public/images/icons/dashboard/settings.svg';
import ImagesIconsDashboardShoppingCartSvg from '@/public/images/icons/dashboard/shopping-cart.svg';
import ImagesIconsDashboardSuggestBottleSvg from '@/public/images/icons/dashboard/suggest-bottle.svg';
import ImagesIconsDashboardTicketSvg from '@/public/images/icons/dashboard/ticket.svg';
import ImagesIconsDashboardWishlistSvg from '@/public/images/icons/dashboard/wishlist.svg';

export {
  ImagesIconsDashboardAccountDetailsHeadingSvg,
  ImagesIconsDashboardAccountSvg,
  ImagesIconsDashboardBellSvg,
  ImagesIconsDashboardBuyerProfileSvg,
  ImagesIconsDashboardCheckWhiteSvg,
  ImagesIconsDashboardDashboardSvg,
  ImagesIconsDashboardFeedbackSvg,
  ImagesIconsDashboardFileTextSvg,
  ImagesIconsDashboardLanguageSvg,
  ImagesIconsDashboardLeftSvg,
  ImagesIconsDashboardLogoutSvg,
  ImagesIconsDashboardPortfolioSvg,
  ImagesIconsDashboardReferralsSvg,
  ImagesIconsDashboardSandClockSvg,
  ImagesIconsDashboardSecuritySvg,
  ImagesIconsDashboardSellerProfileSvg,
  ImagesIconsDashboardSellingSvg,
  ImagesIconsDashboardServicesSvg,
  ImagesIconsDashboardSettingsSvg,
  ImagesIconsDashboardShoppingCartSvg,
  ImagesIconsDashboardSuggestBottleSvg,
  ImagesIconsDashboardTicketSvg,
  ImagesIconsDashboardWishlistSvg,
};
